import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[invdFileDragDrop]',
})
export class DragDropFileDirective {
  @Output() filesDropped = new EventEmitter<FileList>();
  @Output() filesHovered = new EventEmitter<boolean>();
  @Input() isMultipleFiles = false;

  @HostListener('drop', ['$event']) onDrop($event) {
    $event.preventDefault();
    const transfer = $event.dataTransfer;
    if (transfer.files.length > 1) {
      this.isMultipleFiles = true;
    }
    this.filesDropped.emit(transfer.files);
    this.filesHovered.emit(false);
  }

  @HostListener('dragover', ['$event']) onDragOver($event) {
    $event.preventDefault();
    this.filesHovered.emit(true);
  }

  @HostListener('dragleave', ['$event']) dragLeave($event) {
    $event.preventDefault();
    this.filesHovered.emit(false);
  }
}
